export interface Volume {
  number: string;
  title: string;
  description: string;
  tag: string;
  coverImage: string;
}

const covers = [
  'https://cdn.magicpatterns.com/uploads/6UPTffLknvyYrDTRXnyvPA/ChatGPT-Image-21-jul-2026_-06_23_34-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/hBNBxZ4ryr1KoYVXVs9urw/ChatGPT-Image-21-jul-2026_-06_23_40-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/hrQM47RHycoXn5Kqd6Lar2/ChatGPT-Image-21-jul-2026_-06_23_46-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/w2uvKZwqVDf2HoekqnhcU3/ChatGPT-Image-21-jul-2026_-06_23_51-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/uocEbCv2X1v5cQ5jRy9Lnv/ChatGPT-Image-21-jul-2026_-06_23_56-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/usTH22qxaEwnazKL6YbJp2/ChatGPT-Image-21-jul-2026_-06_24_01-p.m..webp',
];

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'A1 Foundations',
    description:
      'Help absolute beginners build confidence from day one. Greetings, introductions, essential classroom language and present simple basics. A strong foundation to help A1 learners feel comfortable using English.',
    tag: '50 pages · Classroom-ready lessons included',
    coverImage: covers[0],
  },
  {
    number: '02',
    title: 'A1 Everyday Life',
    description:
      'Take students beyond the classroom and into real life. Daily routines, shopping, food vocabulary and basic social interaction. Structured lessons that connect English to the world they already know.',
    tag: '50 pages · Real-world scenarios included',
    coverImage: covers[1],
  },
  {
    number: '03',
    title: 'A2 Confidence Builder',
    description:
      'The bridge to real communication. Past tense, future plans, jobs and basic technology vocabulary. Lessons designed to make A2 students feel genuinely capable of expressing themselves in English.',
    tag: '50 pages · Speaking activities included',
    coverImage: covers[2],
  },
  {
    number: '04',
    title: 'A2 Real-World Communication',
    description:
      'English for the situations that actually matter. Travel, phone calls, social etiquette and practical problem-solving. Your students will handle real conversations with confidence.',
    tag: '50 pages · Role-play scripts included',
    coverImage: covers[3],
  },
  {
    number: '05',
    title: 'B1 Fluency Essentials',
    description:
      'Where students stop surviving and start thriving in English. Opinions, debates, social habits, media literacy and storytelling. Lessons that develop critical thinking alongside language skills.',
    tag: '50 pages · Discussion frameworks included',
    coverImage: covers[4],
  },
  {
    number: '06',
    title: 'B1 Independent Speaker',
    description:
      'The final step in the A1-to-B1 journey. Job preparation, presentations, formal writing and project-based learning. Lessons that prepare students for real academic and professional settings.',
    tag: '50 pages · Project templates included',
    coverImage: covers[5],
  },
];

export interface Bonus {
  badge: string;
  icon: string;
  title: string;
  description: string;
  value: string;
}

export const bonuses: Bonus[] = [
  {
    badge: 'BONUS 1',
    icon: '📚',
    title: 'The ESL Grammar Rescue Kit',
    description:
      'Your go-to grammar reference for unexpected classroom questions. 20 complete grammar sections with clear formulas, real examples, common mistakes and ready-to-use classroom activities. The resource you can turn to when a student asks an unexpected grammar question.',
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 2',
    icon: '📅',
    title: '52 Weekly ESL Themes',
    description:
      'A full year of fresh lesson ideas in one convenient download. Every theme includes key vocabulary, grammar tie-ins, speaking prompts, writing tasks and creative extensions.',
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 3',
    icon: '🎙️',
    title: "The Teacher's Classroom Script Library",
    description:
      'Exact phrases for every classroom situation. 15 complete script sections covering how to open a class, correct mistakes, motivate students, manage behavior and close a lesson with impact. Never search for the right words again.',
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 4',
    icon: '📊',
    title: 'The ESL Assessment Toolkit',
    description:
      'Complete, ready-to-use tests, rubrics and progress trackers for A1, A2 and B1 levels. Placement tests, speaking rubrics, writing rubrics, 10 quick quizzes and student progress cards. Assess with confidence and track real results every term.',
    value: 'Value: $47 USD',
  },
];

export interface Testimonial {
  text: string;
  name: string;
  city: string;
  role: string;
  initials: string;
}

export const testimonials: Testimonial[] = [
  {
    text: 'I had been improvising every class for years. With this system I built a real weekly structure in less than one week. Volume 3 alone was worth every cent.',
    name: 'Sarah M.',
    city: 'Toronto, Canada',
    role: 'Independent ESL Teacher',
    initials: 'SM',
  },
  {
    text: 'The Grammar Rescue Kit completely changed how I handle unexpected grammar questions in class. I used to panic. Now I just open the kit and teach with total confidence.',
    name: 'James R.',
    city: 'Manchester, United Kingdom',
    role: 'ESL Teacher & Language Coach',
    initials: 'JR',
  },
  {
    text: 'The classroom scripts from Bonus 3 were exactly what I needed. Having the exact phrases for correction and motivation made me feel like a completely different teacher from day one.',
    name: 'Anjali P.',
    city: 'Mumbai, India',
    role: 'EFL Teacher — Secondary School',
    initials: 'AP',
  },
  {
    text: 'I thought it was just another PDF bundle. It turned out to be the most complete teaching resource I have ever used. The Assessment Toolkit saves me hours every single term.',
    name: 'Karen T.',
    city: 'Sydney, Australia',
    role: 'ESL Teacher — Language Institute',
    initials: 'KT',
  },
  {
    text: 'I bought it from the Philippines and downloaded everything in minutes. The quality and depth of the content are unlike anything else I have found. My students noticed the difference immediately.',
    name: 'Maria R.',
    city: 'Manila, Philippines',
    role: 'Online ESL Teacher',
    initials: 'MR',
  },
  {
    text: 'The 52 Weekly Themes from Bonus 2 saved my entire school year. I used to spend every Sunday deciding what to teach. Now my whole week is planned in 5 minutes.',
    name: 'Laura N.',
    city: 'Johannesburg, South Africa',
    role: 'ESL Teacher — Primary & Secondary',
    initials: 'LN',
  },
  {
    text: 'I teach online and the system works perfectly for virtual classes. Volume 6 gave me everything I needed to run my online classes more professionally, teach with greater confidence, and charge what my work is worth.',
    name: 'Oluwaseun A.',
    city: 'Lagos, Nigeria',
    role: 'Online ESL Teacher — Global',
    initials: 'OA',
  },
];

export interface PurchaseNotification {
  name: string;
  location: string;
  time: string;
}

export const notifications: PurchaseNotification[] = [
  { name: 'Sarah M.', location: 'Toronto, Canada', time: '2 minutes ago' },
  { name: 'James R.', location: 'Manchester, United Kingdom', time: '5 minutes ago' },
  { name: 'Anjali P.', location: 'Mumbai, India', time: '8 minutes ago' },
  { name: 'Maria R.', location: 'Manila, Philippines', time: '14 minutes ago' },
];

export const faqs = [
  {
    question: 'How do I receive the system after purchasing?',
    answer:
      'You receive immediate access to all files after purchase. Download them on any device—no app required.',
  },
  {
    question: 'Is this a one-time payment or a subscription?',
    answer:
      'This is a one-time payment only. You pay once and get lifetime access to all files. There are no recurring charges, no monthly fees, and no hidden costs of any kind.',
  },
  {
    question: 'Can I purchase from my country?',
    answer:
      'Yes. The system is available worldwide. The platform automatically detects your country and converts the price to your local currency at checkout.',
  },
  {
    question: "What if it doesn't work for me?",
    answer:
      'You are covered by a 14-day money-back guarantee. If for any reason the system is not what you expected, contact us within 14 days and we will refund 100% of your investment. No questions asked.',
  },
  {
    question: 'Is this a video course or does it include certification?',
    answer:
      'No. This is a professional PDF bundle designed for immediate classroom use. It is not a video course and does not include academic certification. It is a complete, ready-to-use teaching system.',
  },
  {
    question: 'Do I need to install anything to use it?',
    answer:
      'No. Everything is delivered as standard PDF files. You can open them on any device—phone, tablet, or computer—using any free PDF reader. No special software is required.',
  },
];

export const CHECKOUT_URL = 'https://the-esl-survival-vault.impultienda.ar/checkout';
